/**
 * @fileoverview Models for receiving data about alternate brand name configurations for use in
 * the Specify Listings Settings Page.
 *
 * This is adapted from ListingsStorm2.
 *
 * @author Heesun Jun (hjun@yext.com)
 */


import {AltBrandNamesConfig, AltBrandNamesConfigJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/specifylistingconfiguration/data/altbrandnamesconfig';
import {DeliveryConfiguration, DeliveryConfigurationJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/specifylistingconfiguration/data/deliveryconfiguration';

export class ListingConfiguration {
  /**
   * @param {{
   *  profileField: (AltBrandNamesConfig | undefined),
   *  deliveryConfigurationMap: !Map<number, DeliveryConfiguration>,
   *  applyToExistingSubAccounts: boolean,
   *  applyToNewSubAccounts: boolean,
   * }} params
   */
  constructor(params) {
    /** @type {(AltBrandNamesConfig | undefined)} */
    this.profileField = params.profileField;
    /** @type {!Map<number, DeliveryConfiguration>} */
    this.deliveryConfigurationMap = params.deliveryConfigurationMap;
    /** @type {boolean} */
    this.applyToExistingSubAccounts = params.applyToExistingSubAccounts;
    /** @type {boolean} */
    this.applyToNewSubAccounts = params.applyToNewSubAccounts;
  }

  /**
   * @return {!ListingConfigurationJson}
   */
  toJSON() {
    return {
      'selectedAltBrandName': this.profileField?.toJSON(),
      'deliveryConfigurations': DeliveryConfiguration.toJSONFromMap(this.deliveryConfigurationMap),
      'existingSubAccountsEnabled': this.applyToExistingSubAccounts,
      'newSubAccountsEnabled': this.applyToNewSubAccounts,
    };
  }

  /**
   * @param {!ListingConfigurationJson} json
   * @return {!ListingConfiguration}
   */
  static fromJSON(json) {
    const selectedProfileField = json['selectedAltBrandName'];
    return new ListingConfiguration({
      profileField: selectedProfileField
        ? AltBrandNamesConfig.fromJSON(selectedProfileField)
        : undefined,
      deliveryConfigurationMap: DeliveryConfiguration
        .buildMapFromJSON(json['deliveryConfigurations']),
      applyToExistingSubAccounts: json['existingSubAccountsEnabled'],
      applyToNewSubAccounts: json['newSubAccountsEnabled'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  selectedAltBrandName: (AltBrandNamesConfigJson | undefined),
 *  deliveryConfigurations: !Array<DeliveryConfigurationJson>,
 *  existingSubAccountsEnabled: boolean,
 *  newSubAccountsEnabled: boolean,
 * }}
 */
export var ListingConfigurationJson;
